import type { ReactNode } from 'react'
import { Estado } from '../componentes/Estado'
import type { Permissao } from '../api/acesso'
import { useSessao } from './useSessao'
import { Entrar } from '../paginas/Entrar'

/**
 * Guarda de tela.
 *
 * Isto é conveniência de navegação, não controle de acesso — quem impede a
 * ação é o servidor, a cada requisição. Se esta guarda fosse a única barreira,
 * bastaria o usuário editar o estado no navegador para "entrar".
 */
export function Protegido({
  exige,
  children,
}: {
  exige?: Permissao
  children: ReactNode
}) {
  const { estado, pode, usuario } = useSessao()

  if (estado === 'verificando') return <Estado tipo="carregando" />

  if (estado === 'anonimo') return <Entrar />

  // 🔴 **Sessão do painel embutido sem a permissão da tela ⇒ login** (277 · F1). O cookie é o
  // mesmo das duas: quem abre o portal a partir do Chatwoot chega com ela, e mostrar "sem
  // permissão" o deixaria sem saída. O login troca o cookie, e a URL (com o `?conversa=`)
  // continua a mesma.
  //
  // ⚠️ **Só quando falta a permissão** (3ª revisão, M2): o `/acervo`, que o link *"Historico
  // anterior (Zintech)"* abre a partir de 4.228 contatos, é alcançado DIRETO pela sessão
  // embutida (`AcervoVer` está no escopo) — pedir login ali seria regressão.
  if (usuario?.embutida && (!exige || !pode(exige))) return <Entrar />

  if (exige && !pode(exige)) return <Estado tipo="semPermissao" />

  return <>{children}</>
}
